import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';

class StackQuarterbackWithPassReceivers extends Component {
    onChange(isChecked) {
        this.props.dispatch(Action.do('stackQuarterbackWithPassReceivers', isChecked));
    }

    render() {
        const {lineupsFilter} = this.props;
        const isChecked = lineupsFilter.stackQuarterbackWithPassReceivers;

        return (
            <div>
                <div className="checkbox">
                    <label>
                        <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={(e) => ::this.onChange(e.target.checked)}
                        />
                        If QB is CPT/MVP then use at least one WR/TE from the Same Team
                    </label>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {filters: lineupsFilter} = state.lineupsData;

    return {
        lineupsFilter,
    };
}

export default connect(mapStatesToProps)(StackQuarterbackWithPassReceivers);
